import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import Url from 'url-parse';

import { select } from '@swf/core/store';
import { fetchJson } from '@swf/core/utils/api';

export interface Props extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  href: string;
}

const InternalLink: React.FC<Props> = ({ onClick, href, ...props }) => {
  const isAuthenticated = useSelector(select.session.isAuthenticated);
  const { token, signature, userWebId: webid } = useSelector(select.session.getLegacySession);

  const handleClick = useCallback(
    (e) => {
      if (isAuthenticated) {
        e.preventDefault();
        const { origin } = new Url(href);
        const ramOrigin = origin.replace(/\/\/(?:www|casino)?\.?/, '//ram.');
        const url = new Url(`${ramOrigin}/ram/verifylogin`, true);
        url.set('protocol', 'https');
        url.set('query', { token, signature, webid });
        // Attempt to login to RAMv1 across domain
        fetchJson(url.toString(), { credentials: 'include' }).finally(() =>
          window.location.assign(href)
        );
      }

      if (onClick) {
        onClick(e);
      }
    },
    [isAuthenticated, onClick, href, token, signature, webid]
  );

  return (
    <a {...props} onClick={handleClick} href={href}>
      {props.children}
    </a>
  );
};

export default InternalLink;
